var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $gvars = Opal.gvars, $truthy = Opal.truthy;

  Opal.add_stubs(['$setPrefixes', '$gsub', '$==', '$getDiceList', '$[]', '$>=', '$>']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Gorilla');

    var $nesting = [self].concat($parent_nesting), $Gorilla_initialize$1, $Gorilla_gameName$2, $Gorilla_gameType$3, $Gorilla_getHelpMessage$4, $Gorilla_isGetOriginalMessage$5, $Gorilla_changeText$6, $Gorilla_check_2D6$8;

    
    self.$setPrefixes(["G.*"]);
    
    Opal.def(self, '$initialize', $Gorilla_initialize$1 = function $$initialize() {
      var $iter = $Gorilla_initialize$1.$$p, $yield = $iter || nil, self = this;

      if ($iter) $Gorilla_initialize$1.$$p = null;
      return $send(self, Opal.find_super_dispatcher(self, 'initialize', $Gorilla_initialize$1, false), [], null)
    }, $Gorilla_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $Gorilla_gameName$2 = function $$gameName() {
      var self = this;

      return "ゴリラTRPG"
    }, $Gorilla_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $Gorilla_gameType$3 = function $$gameType() {
      var self = this;

      return "Gorilla"
    }, $Gorilla_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $Gorilla_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "2D6ロール時のゴリティカル自動判定を行います。\n" + "\n" + "G = 2D6のショートカット\n" + "\n" + "例) G>=7 : 2D6して7以上なら成功\n"
    }, $Gorilla_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$isGetOriginalMessage', $Gorilla_isGetOriginalMessage$5 = function $$isGetOriginalMessage() {
      var self = this;

      return false
    }, $Gorilla_isGetOriginalMessage$5.$$arity = 0);
    
    Opal.def(self, '$changeText', $Gorilla_changeText$6 = function $$changeText(string) {
      var $$7, self = this;

      
      string = $send(string, 'gsub', [/^(S)?G/i], ($$7 = function(){var self = $$7.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + "2D6";}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      return string;
    }, $Gorilla_changeText$6.$$arity = 1);
    return (Opal.def(self, '$check_2D6', $Gorilla_check_2D6$8 = function $$check_2D6(totalValue, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var self = this, diceList = nil;

      
      if ($truthy(dice_n['$=='](10))) {
        
        diceList = self.$getDiceList();
        if ($truthy(diceList['$[]'](0)['$=='](5))) {
          return " ＞ ゴリティカル（自動的成功）"};};
      if ($truthy(signOfInequality['$=='](">="))) {
        if ($truthy($rb_ge(totalValue, diff))) {
          return " ＞ 成功"}};
      if ($truthy(signOfInequality['$=='](">"))) {
        if ($truthy($rb_gt(totalValue, diff))) {
          return " ＞ 成功"}};
      return " ＞ 失敗";
    }, $Gorilla_check_2D6$8.$$arity = 8), nil) && 'check_2D6';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
